import { TweenMax } from 'gsap';
import { SplitText } from '@/assets/libs/SplitText';

export default function text(el) {
  const split = new SplitText(el.children, { type: 'lines', linesClass: 'line' });
  const em = [...Array.from(el.querySelectorAll('em')), ...Array.from(el.querySelectorAll('i'))];

  const size = el.dataset.size;

  const amount = window.innerWidth < 769 ? 15 : size === 'small' ? 20 : 50;

  TweenMax.set(el, {
    perspective: 500,
    y: 50,
  });

  // TweenMax.set(split.lines, {
  //   autoAlpha: 0,
  //   y: 80,
  //   scaleY: 1.2,
  // });

  TweenMax.staggerTo(split.lines, 0, {
    x: 0,
    rotationX: -80,
    autoAlpha: 0,
    cycle: {
      y: i => (Math.min(i, 5) * 0.6) * amount,
    },
  });

  TweenMax.set(em, {
    backgroundImage: 'linear-gradient(to right, #474752 0%, #F2F2F2 0%)',
  });

  return el;
}
